/**
 * Created by Pankaj singh on 2020-04-03.
 */
import {Helper} from "@nolimitcity/slot-game/bin/core/utils/Helper";
import {ISymbolPositions} from "./GenieFeatureController";
import {GameConfig} from "@nolimitcity/slot-game/bin/core/gameconfig/GameConfig";
import {IPosition} from "../initial/RomanEmpireInitialWPController";
import {GameResources} from "@nolimitcity/slot-game/bin/core/resource/GameResources";


export class Multiplier extends PIXI.Container {

    private _reelId: number;
    private readonly _symbolId: number;
    private readonly _text: PIXI.BitmapText;
    private _value: number;
    private _spiralPoints: any[] = [];
    private _spiralPointsReverse: any[] = [];
    private _targetPos: IPosition;
    private readonly _isNotRandom: boolean = false;
    private _bg: PIXI.Sprite;

    //private _bgSquare : PIXI.Sprite;
    constructor(value: number, isNotRandom: boolean = false, reelId: number, symbolId: number) {
        super();
        this._reelId = reelId;
        this._symbolId = symbolId;
        this._value = value;
        this._isNotRandom = isNotRandom;
        isNotRandom && this.addBgPatch(value);

        this._text = this.createMultiplierText();
        this.addChild(this._text);
        isNotRandom && this.setPosition(reelId, symbolId);
    }

    private addBgPatch(textVal: number) {
        this._bg = new PIXI.Sprite(GameResources.getTextures("patchCircle")[0]);
        //this._bgSquare = new PIXI.Sprite(GameResources.getTextures("patchSquare")[0]);
        this._bg.tint = 0xFFBE1F;
        this._bg.alpha = 0.8;
        //this._bgSquare.tint = 0xFFBE1F;
        this._bg.anchor.set(0.5, 0.5);
        this._bg.scale.set(textVal > 9 ? 1 : 0.7);

        //this._bgSquare.anchor.set(0.5);
        this.addChild(this._bg);
        //this.alpha = 0.7; //Added to fix #199
    }

    private setPosition(reelId: number, symbolId: number) {
        const pos = Helper.getSymbolPositions(reelId, symbolId);
        // this._targetPos = {
        //     x: pos[0] + GameConfig.instance.SYMBOL_WIDTH * 0.5 - this._text.width * 0.5,
        //     y: pos[1] + GameConfig.instance.SYMBOL_HEIGHT * 0.5 - this._text.height * 0.6,
        // };
        this._targetPos = {
            x: pos[0] + GameConfig.instance.SYMBOL_WIDTH * 0.25, //Added to fix #199
            y: pos[1] + GameConfig.instance.SYMBOL_HEIGHT * 0.25// - this._text.height * 0.6,
        };
    }

    /**
     * Multiplier value from sprite
     */
    private createMultiplierText(): PIXI.BitmapText {
        let multiplierText: PIXI.BitmapText = this.createBitmapText("x" + this._value, [0, -15], "center");
        multiplierText.anchor = 0.5;
        //multiplierText.pivot.y = multiplierText.height * 0.3;
        return multiplierText;
    }

    /**
     * To create Text from Bitmap font images
     * */
    private createBitmapText(text: string, position?: ISymbolPositions | number[], align?: string): PIXI.BitmapText {
        const bitmapText: PIXI.BitmapText = new PIXI.BitmapText(text, {
            fontName: "NumbersWinCountUp",
            fontSize: this._isNotRandom ? 16 : 22,
            align: align || "center"
        });
        if (position) {
            position = position instanceof Array ? position : Helper.getSymbolPositions(position.reelId, position.symbolId);
            bitmapText.position.set(position[0], position[1]);
        }
        return bitmapText;
    }


    get value(): number {
        return this._value;
    }

    set value(value: number) {
        this._value = value;
        this._text.text = "x" + value;
    }

    get reelId(): number {
        return this._reelId;
    }

    set reelId(value: number) {
        this._reelId = value;
    }

    get symbolId(): number {
        return this._symbolId;
    }

    get bg(): PIXI.Sprite {
        return this._bg;
    }

    get text(): PIXI.BitmapText {
        return this._text;
    }

    get spiralPointsReverse(): any[] {
        return this._spiralPointsReverse;
    }

    set spiralPointsReverse(value: any[]) {
        this._spiralPointsReverse = value;
    }

    get targetPos(): IPosition {
        return this._targetPos;
    }

    get spiralPoints(): any[] {
        return this._spiralPoints;
    }

    set spiralPoints(value: any[]) {
        this._spiralPoints = value;
    }

}